import React from "react";

/* type Props = {
  accordionList: any[];
  groupedColumns: Record<string, any[]>;
  gridRowsByAccordion: Record<string, any[]>;
  openKeys: Set<string>;
    toggleAccordion: (key: string) => void;
}; */

type Props = {
    accordionList: any[];
    groupedColumns: Record<string, any[]>;
    gridRowsByAccordion: Record<string, any[]>;
    openKeys: Set<string>;

    toggleAccordion: (key: string) => void;

    selectionStart: any;
    selectionEnd: any;

    setSelectionStart: React.Dispatch<any>;
    setSelectionEnd: React.Dispatch<any>;

    isCellSelected: any;

    columnWidths: Record<string, number>;
    getWidth: (key: string) => number;

    handleResizeStart: any;
    autoFitColumn: any;

    formatDisplayValue: (value:any)=>string;

  tableContainerRef: React.RefObject<HTMLDivElement | null>;

    selectAllTable:string|null;
    setSelectAllTable:any;

    isSelecting:boolean;
    setIsSelecting:any;

    handleKeyDown:any;
    defaultColumnWidth: number;

    onSelectAll: (accordionKey: string) => void;
    onTakeoffClick: (takeoffNo?: number) => void;
};

const MetricsExcelSheet: React.FC<Props> = ({
  accordionList,
  groupedColumns,
  gridRowsByAccordion,
  openKeys,
  toggleAccordion,

  selectionStart,
  selectionEnd,
  setSelectionStart,
  setSelectionEnd,

  isCellSelected,

  columnWidths,
  getWidth,

  handleResizeStart,
  autoFitColumn,

  formatDisplayValue,

  tableContainerRef,

  selectAllTable,
  setSelectAllTable,

  isSelecting,
  setIsSelecting,

  handleKeyDown,
  defaultColumnWidth,
  onSelectAll,
  onTakeoffClick,
}) => {

  // Find the maximum number of dynamic columns across all groups
  const maxDynamicColumns = Math.max(
    0,
    ...accordionList.map(
      (item) => (groupedColumns[item.accordionKey] ?? []).length
    )
  );

 /*  const masterColumns = React.useMemo(() => {
  const map = new Map<string, any>();

  accordionList.forEach((item) => {
    (groupedColumns[item.accordionKey] ?? []).forEach((c) => {
      if (!map.has(c.columnName)) {
        map.set(c.columnName, c);
      }
    });
  });

  return Array.from(map.values());
}, [accordionList, groupedColumns]); */

  return (
   <div
  ref={tableContainerRef}
  tabIndex={0}
  onKeyDown={handleKeyDown}
 onMouseUp={() => setIsSelecting(false)}
  className="w-full border border-gray-400 rounded overflow-auto bg-white select-none"
>
    
    <table className="border-collapse table-fixed ">
   {/* <table className="border-collapse table-fixed w-max"> */}
        <tbody>
          {accordionList.map((item, index) => {

           /*  const columns =
              groupedColumns[item.accordionKey] ?? []; */
             const columns =
  groupedColumns[item.accordionKey] ?? [];
            
  const rows =
              gridRowsByAccordion[item.accordionKey] ?? [];
              
              const childNames = Array.from(
  new Set(
    rows
      .map((r) => r.childName)
      .filter((v) => v != null && v !== "")
  )
);

const wgNames = Array.from(
  new Set(
    rows
      .map((r) => r.wgName)
      .filter((v) => v != null && v !== "")
  )
);

const workNames = Array.from(
  new Set(
    rows
      .map((r) => r.workName)
      .filter((v) => v != null && v !== "")
  )
);

const headerParts = [
  item.geometry,
  childNames.length === 1 ? childNames[0] : null,
  wgNames.length === 1 ? wgNames[0] : null,
  workNames.length === 1 ? workNames[0] : null,
].filter(Boolean);

const showChildColumn = childNames.length > 1;
const showWGColumn = wgNames.length > 1;
const showWorkColumn = workNames.length > 1;

            const isOpen =
              openKeys.has(item.accordionKey);

            /* const emptyColumnCount =
              maxDynamicColumns - columns.length; */

             

            return (
              <React.Fragment key={item.accordionKey}>

                {/* Group Row */}
              <tr
  className="bg-gray-200 h-8 cursor-pointer hover:bg-gray-300"
  onClick={() => toggleAccordion(item.accordionKey)}
>
                  <td
                    //colSpan={4 + maxDynamicColumns}
                    colSpan={
  4 +
  maxDynamicColumns +
  (showChildColumn ? 1 : 0)  +
  (showWGColumn ? 1 : 0) +
  (showWorkColumn ? 1 : 0)
}
                    className="border border-gray-300 px-2 py-1 font-semibold"
                  >
                    {isOpen ? "▼" : "▶"} Group {index + 1}
                    {headerParts.length > 0 ? ` - ${headerParts.join(" - ")}` : ""}
                  </td>
                </tr>

                {isOpen && (
                  <>

                    {/* Header Row */}
                   {/* <tr className="bg-gray-100 h-8"> */}
                   <tr className="bg-white h-8">

                     {/* <th className="border border-gray-300 px-2 py-1 w-16">
                        S.No
                      </th> */}

                      <th
  className={`border border-gray-300 px-2 py-1 w-16 cursor-pointer ${
    selectAllTable === item.accordionKey
      ? "!bg-[#d9d9d9]"
      : ""
  }`}
  style={{
    textAlign: "center",   
    color: "#808080",
  }}
  onMouseDown={() => onSelectAll(item.accordionKey)}
>
  ◢
</th>

                    {showChildColumn && (
  <th
    title="Child Name"
     style={{ width: 
    
      getWidth(`${item.accordionKey}__childName`),
        minWidth: getWidth(`${item.accordionKey}__childName`),
  maxWidth: getWidth(`${item.accordionKey}__childName`),
     }} 
    

    onMouseDown={(e) => {
  e.stopPropagation();

  setSelectAllTable(null);
  setIsSelecting(true);

  setSelectionStart({
    accordionKey: item.accordionKey,
    row: -1,
    column: "childName",
  });

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "childName",
  });

  tableContainerRef.current?.focus();
}}

onMouseEnter={() => {
  if (!isSelecting) return;

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "childName",
  });
}}
    //className="relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate"
    /* className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey
    ? "!bg-[#d9d9d9]"
    : ""
}`} */
className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey ||
  isCellSelected(
    item.accordionKey,
    -1,
    "childName",
    [
      "__rowNumber__",
      ...(showChildColumn ? ["childName"] : []),
      ...(showWGColumn ? ["wgName"] : []),
      ...(showWorkColumn ? ["workName"] : []),
      "notation",
      "takeOff",
      "quantity",
      ...columns.map(c => c.columnName),
    ]
  )
    ? "!bg-[#d9d9d9]"
    : "" 
   
}`}
  >
    Child Name

    <div
      className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20"
      onPointerDown={(e) =>
        handleResizeStart(
          e,
          //"childName",
           `${item.accordionKey}__childName`,
          item.accordionKey,
          "childName",
          "Child Name",
          rows.map(r => r.childName)
        )
      }
      onDoubleClick={() =>
        autoFitColumn(
          item.accordionKey,
          "childName",
          "Child Name",
          rows.map(r => r.childName)
        )
      }
    />
  </th>
)}


{showWGColumn && (
  <th
    title="WG Name"
    style={{ width:
       //getWidth("wgName") 
       getWidth(`${item.accordionKey}__wgName`),
       minWidth: getWidth(`${item.accordionKey}__wgName`),
  maxWidth: getWidth(`${item.accordionKey}__wgName`),
      }}
  onMouseDown={(e) => {
  e.stopPropagation();

  setSelectAllTable(null);
  setIsSelecting(true);

  setSelectionStart({
    accordionKey: item.accordionKey,
    row: -1,
    column: "wgName",
  });

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "wgName",
  });

  tableContainerRef.current?.focus();
}}

onMouseEnter={() => {
  if (!isSelecting) return;

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "wgName",
  });
}}
   /* className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey
    ? "!bg-[#d9d9d9]"
    : ""
}`} */

className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey ||
  isCellSelected(
    item.accordionKey,
    -1,
    "wgName",
    [
      "__rowNumber__",
      ...(showChildColumn ? ["childName"] : []),
      ...(showWGColumn ? ["wgName"] : []),
      ...(showWorkColumn ? ["workName"] : []),
      "notation",
      "takeOff",
      "quantity",
      ...columns.map(c => c.columnName),
    ]
  )
    ? "!bg-[#d9d9d9]"
    : ""
}`}
  >
    WG Name

    <div
      className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20"
      onPointerDown={(e) =>
        handleResizeStart(
          e,
          //"wgName",
          `${item.accordionKey}__wgName`,
          item.accordionKey,
          "wgName",
          "WG Name",
          rows.map(r => r.wgName)
        )
      }
      onDoubleClick={() =>
        autoFitColumn(
          item.accordionKey,
          "wgName",
          "WG Name",
          rows.map(r => r.wgName)
        )
      }
    />
  </th>
)}
{showWorkColumn && (
  <th
    title="Work Name"
    style={{ width:
       //getWidth("workName") 
       getWidth(`${item.accordionKey}__workName`),
         minWidth: getWidth(`${item.accordionKey}__workName`),
  maxWidth: getWidth(`${item.accordionKey}__workName`),
      }}
    onMouseDown={(e) => {
  e.stopPropagation();

  setSelectAllTable(null);
  setIsSelecting(true);

  setSelectionStart({
    accordionKey: item.accordionKey,
    row: -1,
    column: "workName",
  });

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "workName",
  });

  tableContainerRef.current?.focus();
}}

onMouseEnter={() => {
  if (!isSelecting) return;

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "workName",
  });
}}
 
   className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
 // selectAllTable === item.accordionKey
 selectAllTable === item.accordionKey ||
isCellSelected(
  item.accordionKey,
  -1,
  "workName",
  [
    "__rowNumber__",
    ...(showChildColumn ? ["childName"] : []),
    ...(showWGColumn ? ["wgName"] : []),
    ...(showWorkColumn ? ["workName"] : []),
    "notation",
    "takeOff",
    "quantity",
    ...columns.map(c => c.columnName),
  ]
)
    ? "!bg-[#d9d9d9]"
    : ""
}`}
  >
    Work Name

    <div
      className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20"
      onPointerDown={(e) =>
        handleResizeStart(
          e,
         // "workName",
         `${item.accordionKey}__workName`,
          item.accordionKey,
          "workName",
          "Work Name",
          rows.map(r => r.workName)
        )
      }
      onDoubleClick={() =>
        autoFitColumn(
          item.accordionKey,
          "workName",
          "Work Name",
          rows.map(r => r.workName)
        )
      }
    />
  </th>
)}



                    <th
                      title="Notation"
  style={{
   // width: getWidth(`${item.accordionKey}__notation`)
   width: 
   //getWidth("notation")
   getWidth(`${item.accordionKey}__notation`),
   minWidth: getWidth(`${item.accordionKey}__notation`),
  maxWidth: getWidth(`${item.accordionKey}__notation`),
   
  }}
  onMouseDown={(e) => {
  e.stopPropagation();

  setSelectAllTable(null);
  setIsSelecting(true);

  setSelectionStart({
    accordionKey: item.accordionKey,
    row: -1,
    column: "notation",
  });

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "notation",
  });

  tableContainerRef.current?.focus();
}}

onMouseEnter={() => {
  if (!isSelecting) return;

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: "notation",
  });
}}
 // className="relative border border-gray-300 px-2 py-1"
 //className="relative border border-gray-300 px-2 py-1 h-8 whitespace-nowrap overflow-hidden text-ellipsis"
// className="relative border border-gray-300 px-2 py-1 h-8  whitespace-nowrap overflow-hidden truncate"
//  className="relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate"
/* className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey
    ? "!bg-[#d9d9d9]"
    : ""
}`} */
className={`relative border border-gray-300 px-2 py-1 ${
  selectAllTable === item.accordionKey ||
  isCellSelected(
    item.accordionKey,
    -1,
    "notation",
    [
      "__rowNumber__",
      ...(showChildColumn ? ["childName"] : []),
      ...(showWGColumn ? ["wgName"] : []),
      ...(showWorkColumn ? ["workName"] : []),
      "notation",
      "takeOff",
      "quantity",
      ...columns.map(col => col.columnName),
    ]
  )
    ? "!bg-[#d9d9d9]"
    : ""
}`}
>
  Notation

  <div
    //className="absolute top-0 right-0 h-full w-1 cursor-col-resize"
    className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20"
    onPointerDown={(e) =>
      handleResizeStart(
        e,
       // `${item.accordionKey}__notation`,
      // "notation",
      `${item.accordionKey}__notation`,
        item.accordionKey,
        "notation",
        "Notation",
        rows.map(r => r.notation)
      )
    }
    onDoubleClick={() =>
      autoFitColumn(
        item.accordionKey,
        "notation",
        "Notation",
        rows.map(r => r.notation)
      )
    }
  />
</th>

                    {/*  <th className="border border-gray-300 px-2 py-1 w-44">
                        Takeoff
                      </th>

                   <th className="border border-gray-300 px-2 py-1 w-24">
                        Quantity
                      </th>

                      {columns.map((c) => (
                        <th
                          key={c.columnName}
                           className="border border-gray-300 px-2 py-1 w-32"
                        >
                          {c.columnCaption}
                        </th>
                      ))}
 */}
 {/* <th
 
   title="Takeoff"
  style={{ width: getWidth("takeOff") }}
 
className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey
    ? "!bg-[#d9d9d9]"
    : ""
}`}
>
  Takeoff */}
  <th
  title="Takeoff"
  style={{ width: 
    //getWidth("takeOff") 
    getWidth(`${item.accordionKey}__takeOff`),
     minWidth: getWidth(`${item.accordionKey}__takeOff`),
  maxWidth: getWidth(`${item.accordionKey}__takeOff`),
  }}

  onMouseDown={(e) => {
    e.stopPropagation();

    setSelectAllTable(null);
    setIsSelecting(true);

    setSelectionStart({
      accordionKey: item.accordionKey,
      row: -1,
      column: "takeOff",
    });

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: -1,
      column: "takeOff",
    });

    tableContainerRef.current?.focus();
  }}

  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: -1,
      column: "takeOff",
    });
  }}

  className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
    selectAllTable === item.accordionKey ||
    isCellSelected(
      item.accordionKey,
      -1,
      "takeOff",
      [
        "__rowNumber__",
        ...(showChildColumn ? ["childName"] : []),
        ...(showWGColumn ? ["wgName"] : []),
        ...(showWorkColumn ? ["workName"] : []),
        "notation",
        "takeOff",
        "quantity",
        ...columns.map(c => c.columnName),
      ]
    )
      ? "!bg-[#d9d9d9]"
      : ""
  }`}
>
  Takeoff

  <div
    className="absolute top-0 right-0 h-full w-1 cursor-col-resize"
    onPointerDown={(e) =>
      handleResizeStart(
        e,
       `${item.accordionKey}__takeOff`,
        item.accordionKey,
        "takeOff",
        "Takeoff",
        rows.map(r => r.takeOff)
      )
    }
    onDoubleClick={() =>
      autoFitColumn(
        item.accordionKey,
        "takeOff",
        "Takeoff",
        rows.map(r => r.takeOff)
      )
    }
  />


 
</th>

{/* <th
  title="Quantity"
  style={{ width:
     
     getWidth("quantity")
    }}
 
 className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey
    ? "!bg-[#d9d9d9]"
    : ""
}`}
>
  Quantity */}
  <th
  title="Quantity"
  style={{ width: 
    // getWidth("quantity") 
    getWidth(`${item.accordionKey}__quantity`),
      minWidth: getWidth(`${item.accordionKey}__quantity`),
  maxWidth: getWidth(`${item.accordionKey}__quantity`),
  
  }}

  onMouseDown={(e) => {
    e.stopPropagation();

    setSelectAllTable(null);
    setIsSelecting(true);

    setSelectionStart({
      accordionKey: item.accordionKey,
      row: -1,
      column: "quantity",
    });

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: -1,
      column: "quantity",
    });

    tableContainerRef.current?.focus();
  }}

  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: -1,
      column: "quantity",
    });
  }}

  className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
    selectAllTable === item.accordionKey ||
    isCellSelected(
      item.accordionKey,
      -1,
      "quantity",
      [
        "__rowNumber__",
        ...(showChildColumn ? ["childName"] : []),
        ...(showWGColumn ? ["wgName"] : []),
        ...(showWorkColumn ? ["workName"] : []),
        "notation",
        "takeOff",
        "quantity",
        ...columns.map(c => c.columnName),
      ]
    )
      ? "!bg-[#d9d9d9]"
      : ""
  }`}
>
  Quantity

  <div
    className="absolute top-0 right-0 h-full w-1 cursor-col-resize"
    onPointerDown={(e) =>
      handleResizeStart(
        e,
       `${item.accordionKey}__quantity`,
        item.accordionKey,
        "quantity",
        "Quantity",
        rows.map(r => r.quantity)
      )
    }
    onDoubleClick={() =>
      autoFitColumn(
        item.accordionKey,
        "quantity",
        "Quantity",
        rows.map(r => r.quantity)
      )
    }
  />


  
</th>

{/* {columns.map((c) => (
  <th
    key={c.columnName}
    style={{
      width: getWidth(`${item.accordionKey}__extra-${c.columnName}`),
    }}
    className="relative border border-gray-300 px-2 py-1"
  >
    {c.columnCaption}

    <div
      className="absolute top-0 right-0 h-full w-1 cursor-col-resize"
      onPointerDown={(e) =>
        handleResizeStart(
          e,
          `${item.accordionKey}__extra-${c.columnName}`,
          item.accordionKey,
          `extra-${c.columnName}`,
          c.columnCaption,
          rows.map((r) => r.cells?.[c.columnName])
        )
      }
      onDoubleClick={() =>
        autoFitColumn(
          item.accordionKey,
          `extra-${c.columnName}`,
          c.columnCaption,
          rows.map((r) => r.cells?.[c.columnName])
        )
      }
    />
  </th>
))} */}

{Array.from({ length: maxDynamicColumns }).map((_, index) => {

  const c = columns[index];

  if (!c) {
    return (
      <th
        key={index}
        className="border border-gray-300 px-2 py-1"
       // style={{ width: 120 }}
      
      //{{ width: defaultColumnWidth }}
      style={{
  width: defaultColumnWidth
}}
      />
    );
  }

  return (
    <th
      key={c.columnName}
      title={c.columnCaption}
      /* style={{
      
       width: 
       
        getWidth(`${item.accordionKey}__extra-${c.columnName}`)

      }} */
     style={{
  width: getWidth(`${item.accordionKey}__extra-${c.columnName}`),
  minWidth: getWidth(`${item.accordionKey}__extra-${c.columnName}`),
  maxWidth: getWidth(`${item.accordionKey}__extra-${c.columnName}`),
}}
      onMouseDown={(e) => {
  e.stopPropagation();

  setSelectAllTable(null);
  setIsSelecting(true);

  setSelectionStart({
    accordionKey: item.accordionKey,
    row: -1,
    column: c.columnName,
  });

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: c.columnName,
  });

  tableContainerRef.current?.focus();
}}

onMouseEnter={() => {
  if (!isSelecting) return;

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: -1,
    column: c.columnName,
  });
}}
      
   /*   className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey
    ? "!bg-[#d9d9d9]"
    : ""
}`} */
className={`relative border border-gray-300 px-2 py-1 h-8 text-left whitespace-nowrap overflow-hidden truncate ${
  selectAllTable === item.accordionKey ||
  isCellSelected(
    item.accordionKey,
    -1,
    c.columnName,
    [
      "__rowNumber__",
      ...(showChildColumn ? ["childName"] : []),
      ...(showWGColumn ? ["wgName"] : []),
      ...(showWorkColumn ? ["workName"] : []),
      "notation",
      "takeOff",
      "quantity",
      ...columns.map(col => col.columnName),
    ]
  )
    ? "!bg-[#d9d9d9]"
    : ""
}`}
    >
      {c.columnCaption}

      <div
        className="absolute top-0 right-0 h-full w-1 cursor-col-resize"
        onPointerDown={(e) =>
          handleResizeStart(
            e,
          
           //`extra-${index}`,
            `${item.accordionKey}__extra-${c.columnName}`,
            item.accordionKey,
         
          //  `extra-${index}`,
          `extra-${c.columnName}`,
            c.columnCaption,
            rows.map(r => r.cells?.[c.columnName])
          )
        }
        onDoubleClick={() =>
          autoFitColumn(
            item.accordionKey,
        
          //`extra-${index}`,
          `extra-${c.columnName}`,
            c.columnCaption,
            rows.map(r => r.cells?.[c.columnName])
          )
        }
      />
    </th>

    
  );

})}
                      {/* Empty Header Columns */}
                     {/*  {Array.from({
                        length: emptyColumnCount,
                      }).map((_, index) => (
                        <th
                          key={`empty-header-${index}`}
                          className="border px-2 py-1"
                        />
                      ))} */}

                    </tr>

                    {/* Data */}
                    {rows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
{/* 
                        <td className="border border-gray-300 px-2 py-1 h-8 whitespace-nowrap overflow-hidden">
                          {rowIndex + 1}
                        </td> */}
                        <td
  onMouseDown={(e) => {
    e.stopPropagation();

    setSelectAllTable(null);
    setIsSelecting(true);

    setSelectionStart({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "__rowNumber__",
    });

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "__rowNumber__",
    });

    tableContainerRef.current?.focus();
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "__rowNumber__",
    });
  }}
  className={`border border-gray-300 px-2 py-1 h-8 whitespace-nowrap overflow-hidden ${
    isCellSelected(
      item.accordionKey,
      rowIndex,
      "__rowNumber__",
      [
        "__rowNumber__",
        ...(showChildColumn ? ["childName"] : []),
        ...(showWGColumn ? ["wgName"] : []),
        ...(showWorkColumn ? ["workName"] : []),
        "notation",
        "takeOff",
        "quantity",
        ...columns.map((c) => c.columnName),
      ]
    )
      ? "!bg-[#d9d9d9]"
      : "" 
     /*  ? "!bg-[#bfbfbf]"   // selected S.No cell
: "!bg-[#cccccc]"  // normal S.No cells */
  }`}
>
  {rowIndex + 1}
</td>
                        {showChildColumn && (
  <td
    title={formatDisplayValue(row.childName)}
     style={{
  width: getWidth(`${item.accordionKey}__childName`)
}} 

    onMouseDown={(e) => {
      e.stopPropagation();

      setSelectAllTable(null);
      setIsSelecting(true);

      setSelectionStart({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "childName",
      });


      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "childName",
      });

      tableContainerRef.current?.focus();
    }}
    onMouseEnter={() => {
      if (!isSelecting) return;

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "childName",
      });
    }}
    className={`border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
      isCellSelected(
        item.accordionKey,
        rowIndex,
        "childName",
       /*  [
          "childName",
          "notation",
          "takeOff",
          "quantity",
          ...columns.map(c => c.columnName),
        ] */
       [
          "__rowNumber__",
  ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),

  "notation",
  "takeOff",
  "quantity",

  ...columns.map((c) => c.columnName),
]
      )
        ? "!bg-[#d9d9d9]"
        : ""
    }`}
  >
    {formatDisplayValue(row.childName)}
  </td>
)}
{showWGColumn && (
  <td
    title={formatDisplayValue(row.wgName)}
    style={{
  width: getWidth(`${item.accordionKey}__wgName`)
}}
    onMouseDown={(e) => {
      e.stopPropagation();

      setSelectAllTable(null);
      setIsSelecting(true);

      setSelectionStart({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "wgName",
      });

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "wgName",
      });

      tableContainerRef.current?.focus();
    }}
    onMouseEnter={() => {
      if (!isSelecting) return;

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "wgName",
      });
    }}
    className={`border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
      isCellSelected(
        item.accordionKey,
        rowIndex,
        "wgName",
       [
          "__rowNumber__",
  ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),

  "notation",
  "takeOff",
  "quantity",

  ...columns.map((c) => c.columnName),
]
      )
        ? "!bg-[#d9d9d9]"
        : ""
    }`}
  >
    {formatDisplayValue(row.wgName)}
  </td>
)}
{showWorkColumn && (
  <td
    title={formatDisplayValue(row.workName)}
    style={{
  width: getWidth(`${item.accordionKey}__workName`)
}}
    onMouseDown={(e) => {
      e.stopPropagation();

      setSelectAllTable(null);
      setIsSelecting(true);

      setSelectionStart({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "workName",
      });

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "workName",
      });

      tableContainerRef.current?.focus();
    }}
    onMouseEnter={() => {
      if (!isSelecting) return;

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: "workName",
      });
    }}
    className={`border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
      isCellSelected(
        item.accordionKey,
        rowIndex,
        "workName",
      [
          "__rowNumber__",
  ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),

  "notation",
  "takeOff",
  "quantity",

  ...columns.map((c) => c.columnName),
]
      )
        ? "!bg-[#d9d9d9]"
        : ""
    }`}
  >
    {formatDisplayValue(row.workName)}
  </td>
)}




                       {/*  <td
  title={formatDisplayValue(row.notation)} */}
  <td
   
  /* style={{
    
    width: getWidth("notation")
 
  }} */
  title={formatDisplayValue(row.notation)}
  style={{
  width: getWidth(`${item.accordionKey}__notation`)
}}
  onMouseDown={(e) => {
    e.stopPropagation();

    setSelectAllTable(null);
    setIsSelecting(true);

    setSelectionStart({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "notation",
    });

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "notation",
    });

    tableContainerRef.current?.focus();
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "notation",
    });
  }}
  //className={`border border-gray-300 px-2 py-1 h-8  select-none ${
  className={`border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
// className={`border border-gray-300 px-2 py-1 h-8 whitespace-nowrap overflow-hidden ${
    isCellSelected(
       
      item.accordionKey,
      rowIndex,
      "notation",
      [
 "__rowNumber__",
         ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),
        "notation",
        "takeOff",
        "quantity",
        ...columns.map((c) => c.columnName),
      ]
    )


      ? "!bg-[#d9d9d9]"
      : ""
  }`}
>
    
  {formatDisplayValue(row.notation)}

</td>

                       {/*  <td
  title={formatDisplayValue(row.takeOff)} */}
  <td
  /* style={{
  
   width : getWidth("takeOff")
  }} */
  title={formatDisplayValue(row.takeOff)}
  style={{
  width: getWidth(`${item.accordionKey}__takeOff`)
}}
onClick={() => onTakeoffClick(row.takeoffNo)}
  onMouseDown={(e) => {
    e.stopPropagation();

    setSelectAllTable(null);
    setIsSelecting(true);

    setSelectionStart({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "takeOff",
    });

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "takeOff",
    });

    tableContainerRef.current?.focus();
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "takeOff",
    });
  }}
 // className={`border border-gray-300 px-2 py-1 h-8 select-none ${
// className={`border border-gray-300 px-2 py-1 h-8 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
className={`border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
    isCellSelected(
      item.accordionKey,
      rowIndex,
      "takeOff",
      [
          "__rowNumber__",
         ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),
        "notation",
        "takeOff",
        "quantity",
        ...columns.map((c) => c.columnName),
      ]
    )
      ? "!bg-[#d9d9d9]"
      : ""
  }`}
>
  {/* {formatDisplayValue(row.takeOff)} */}
  <a
  href="#"
  className="text-blue-600 underline hover:text-blue-800 cursor-pointer"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    onTakeoffClick(row.takeoffNo);
  }}
>
  {formatDisplayValue(row.takeOff)}
</a>
</td>

                      {/*   <td
  title={formatDisplayValue(row.quantity)} */}

  <td
 /*  style={{
  
  width: getWidth("quantity")
  }} */
  title={formatDisplayValue(row.quantity)}
  style={{
  width: getWidth(`${item.accordionKey}__quantity`)
}}
  onMouseDown={(e) => {
    e.stopPropagation();

    setSelectAllTable(null);
    setIsSelecting(true);

    setSelectionStart({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "quantity",
    });

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "quantity",
    });

    tableContainerRef.current?.focus();
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      accordionKey: item.accordionKey,
      row: rowIndex,
      column: "quantity",
    });
  }}
  //className={`border border-gray-300 px-2 py-1 h-8 text-right select-none ${
//  className={`border border-gray-300 px-2 py-1 h-8 text-right select-none whitespace-nowrap overflow-hidden text-ellipsis ${
className={`border border-gray-300 px-2 py-1 h-8 text-right max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
    isCellSelected(
      item.accordionKey,
      rowIndex,
      "quantity",
      [
          "__rowNumber__",
         ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),
        "notation",
        "takeOff",
        "quantity",
        ...columns.map((c) => c.columnName),
      ]
    )
      ? "!bg-[#d9d9d9]"
      : ""
  }`}
>
  {formatDisplayValue(row.quantity)}
</td>
{/* 
                       {columns.map((c) => (
 

    <td
  key={c.columnName}
  style={{
    width: getWidth(
      `${item.accordionKey}__extra-${c.columnName}`
    )
  }}
    title={formatDisplayValue(row.cells?.[c.columnName])}
    onMouseDown={(e) => {
      e.stopPropagation();

      setSelectAllTable(null);
      setIsSelecting(true);

      setSelectionStart({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: c.columnName,
      });

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: c.columnName,
      });

      tableContainerRef.current?.focus();
    }}
    onMouseEnter={() => {
      if (!isSelecting) return;

      setSelectionEnd({
        accordionKey: item.accordionKey,
        row: rowIndex,
        column: c.columnName,
      });
    }}
    className={`border border-gray-300 px-2 py-1 h-8 ${
      isCellSelected(
        item.accordionKey,
        rowIndex,
        c.columnName,
        [
          "notation",
          "takeOff",
          "quantity",
          ...columns.map((col) => col.columnName),
        ]
      )
        ? "!bg-[#d9d9d9]"
        : ""
    }`}
  >
    {formatDisplayValue(row.cells?.[c.columnName])}
  </td>
))} */}

{Array.from({ length: maxDynamicColumns }).map((_, index) => {

  const c = columns[index];

  if (!c) {
    return (
      <td
        key={index}
       // className="border border-gray-300 px-2 py-1 h-8 select-none"
       className="border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden"
        style={{ width: defaultColumnWidth }}
      />
    );
  }

  return (
    <td
      key={c.columnName}
       style={{
      
      // width: getWidth(`extra-${index}`)
      width: getWidth(
  `${item.accordionKey}__extra-${c.columnName}`
)
      }} 
      title={formatDisplayValue(row.cells?.[c.columnName])}

onMouseDown={(e) => {
  e.stopPropagation();

  setSelectAllTable(null);
  setIsSelecting(true);

  setSelectionStart({
    accordionKey: item.accordionKey,
    row: rowIndex,
    column: c.columnName,
  });

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: rowIndex,
    column: c.columnName,
  });

  tableContainerRef.current?.focus();
}}

onMouseEnter={() => {
  if (!isSelecting) return;

  setSelectionEnd({
    accordionKey: item.accordionKey,
    row: rowIndex,
    column: c.columnName,
  });
}}
      //className={`border border-gray-300 px-2 py-1 h-8  select-none ${
     // className={`border border-gray-300 px-2 py-1 h-8 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
     className={`border border-gray-300 px-2 py-1 h-8 max-w-0 select-none whitespace-nowrap overflow-hidden text-ellipsis ${
        isCellSelected(
          item.accordionKey,
          rowIndex,
          c.columnName,
          [
              "__rowNumber__",
            ...(showChildColumn ? ["childName"] : []),
  ...(showWGColumn ? ["wgName"] : []),
  ...(showWorkColumn ? ["workName"] : []),

            "notation",
            "takeOff",
            "quantity",
            ...columns.map(col => col.columnName),
          ]
        )
          ? "!bg-[#d9d9d9]"
          : ""
      }`}
    >
      {formatDisplayValue(row.cells?.[c.columnName])}
    </td>
  );

})}

                        {/* Empty Data Cells */}
                      {/*   {Array.from({
                          length: emptyColumnCount,
                        }).map((_, index) => (
                          <td
                            key={`empty-cell-${index}`}
                           className="border border-gray-300 px-2 py-1 h-8"
                          />
                        ))} */}

                      </tr>
                    ))}

                  </>
                )}

              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MetricsExcelSheet;